<div id="auth-page" class="auth-wrap nt-flex">
  <div class="container-fluid nt-flex-col nt-fill-height">
    <div class="row carousel-row nt-flex nt-fill-height">
      @if (showCarousel()) {
        <div class="col-lg-7 nt-fill-height col-md-12 carousel-col">
          <ic-auth-carousel></ic-auth-carousel>
        </div>
      }
      <div [class]="showCarousel() ? 'col-lg-5' : 'col-lg-12'" class="nt-fill-height col-md-12 auth-pages">
        <div class="auth-router-outlet">
          <div class="router-wrap">
            @if (!showCarousel()) {
              <header class="router-header nt-w-100">
                <h1><img src="assets/svg/icentral_logo_black.svg" alt="iCentral"></h1>
              </header>
            }
            <router-outlet></router-outlet>
          </div>
        </div>
        @if (showCarousel()) {
          <ic-auth-footer></ic-auth-footer>
        }
      </div>
    </div>
  </div>
</div>
